
import strings from '../columns.resx';
import { NameHeroField } from '../../fields/nameHero/NameHeroField';
import { Facet } from '../../../models/Facet';
import { createColumn, ColumnWidth } from '../createColumn';
import { IItemColumnRendererProps } from '../../../models/schema/itemColumnRenderControl';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IItemColumn } from '../../../models/schema/IItemColumn';

export const displayNameColumn: IItemColumn = createColumn(
  {
    key: new Facet('displayNameColumn').id,
    name: strings.Name,
    fieldName: '',
    isCollapsible: false,
    minWidth: ColumnWidth.displayNameMin,
    maxWidth: ColumnWidth.displayNameMax
  },
  NameHeroField)((itemCache: IItemCache) => {
    return (item: IItemColumnRendererProps) => {
      return {
        itemKey: item.key,
        onClick: item.isInvokable ? () => {
          // Nothing
        } : undefined,
        isDisabled: item.isDisabled
      };
    };
  });
